









import { defineClassComponent } from '@/hooks'
import { goodsProvider } from '../provider'
import { onBeforeUnmount, onMounted, ref } from '@vue/composition-api'
import { pageBridge } from '@/components'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        onMounted(() => {
          onBeforeUnmount(
            pageBridge.on('scroll', ({ headerParallaxRate }) => {
              this.scrollDelta.value = headerParallaxRate
            }),
          )
        })
      }

      // 商品数据
      goodsData = goodsProvider.inject()

      // 滚动幅度
      scrollDelta = ref(0)

      // 点击返回顶部
      handleBackTopClick = () => {
        document.querySelector('.__page_container__')?.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      }
    },
)
